import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
// import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-CDesign";
import leftimgs from "../../../assets/Webleftimg.png";
import rightimgs from "../../../assets/Webrightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import LearningStyle from "../../../MyComponents/LearningStyle"
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";

import Testimonials from "../../../MyComponents/Testimonials";
 const beginnerModules = [
    {
      
      title: "Module 1",
      activities: "13",
      classes: "07",
      description: " Learn basic web development with HTML tags and elements to create simple web pages.",
    },
    {
      title: "Module 2",
      activities: "11",
      classes: "06",
      description:  "Students will learn to style webpages using text, backgrounds, tables, and basic formatting.",
    },
    
    
  ];

  const advancedModules = [
    {
      title: "Module 1",
      activities: "13",
      classes: "07",
      description: " Fundamentals of HTML- Kids will learn basic HTML tags and elements to create a simple webpage",
    },
    {
      title: "Module 2",
      activities: "13",
      classes: "07",
      description:  " Advance HTML- Students will learn advanced HTML concepts like forms, buttons, and links to build interactive webpages.",
    },
     {
      title: "Module 3",
      activities: "13",
      classes: "07",
      description:  " Introduction to CSS - Kids will learn basic styling techniques like formatting text, backgrounds, and tables using CSS.",
    },
     {
      title: "Module 4",
      activities: "13",
      classes: "07",
      description:  ": Advance CSS- Students will explore advanced styling with Box Model, navigation bars, dropdowns, animations, and transitions.",
    },
     {
      title: "Module 5",
      activities: "09",
      classes: "05",
      description:  " Introduction to JavaScript- Covers variables, conditions, and loops to introduce basic JavaScript programming.",
    },
     {
      title: "Module 6",
      activities: "09",
      classes: "05",
      description:  "JavaScript Object Model- Students will learn arrays, event handling, and form validation using JavaScript.",
    }
    
   
  ];


  const benefitsData = [
      {
        title: "Learn Website Basics",
        description: "Understand the fundamentals of web development.",
        icon: "Polymath-images/Web-benefit-img1.png", //ji
      },
      {
        title: "Understand HTML & CSS",
        description: "Learn the core building blocks of web pages.",
        icon: "Polymath-images/Web-benefit-img2.png",
      },
      {
        title: "Create Responsive Designs",
        description: "Build websites that work across devices.",
        icon: "Polymath-images/Web-benefit-img3.png",
      },
      {
        title: "Add Text & Media",
        description: "Incorporate content like text, images, and videos.",
        icon: "Polymath-images/Web-benefit-img4.png",
      },
      {
        title: "Boost Creativity",
        description: "Enhance your creativity with design and layout.",
        icon: "Polymath-images/Web-benefit-img5.png",
      },
      {
        title: "Learn JavaScript",
        description: "Introduce interactivity and dynamic content.",
        icon: "Polymath-images/Web-benefit-img6.png",
      },
      {
        title: "Structure Web Content",
        description: "Organize content for better user experience.",
        icon: "Polymath-images/Web-benefit-img7.png",
      },
      {
        title: "Improve Logic Skills",
        description: "Develop problem-solving and coding skills.",
        icon: "Polymath-images/Web-benefit-img8.png",
      },
      {
        title: "Build Real Projects",
        description: "Apply your knowledge to create functional websites.",
        icon: "Polymath-images/Web-benefit-img9.png",
      },
    ];
    const activitiesData = [
        {
          title: "FM Radio App",
          image: "Polymath-images/WebFun-img1.png",
        },
        {
          title: "Light Bulb App",
          image: "Polymath-images/WebFun-img2.png",
        },
        {
          title: "Walking Step App",
          image: "Polymath-images/WebFun-img3.png",
        },
        {
          title: "Animal Sound App",
          image: "Polymath-images/WebFun-img4.png",
        },
        {
          title: "Dictionary",
          image: "Polymath-images/WebFun-img5.png",
        },
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "", // Replace with the actual video URL
  };
const WebDevelopment = () => {
  const Apppage = heroContent.websection;
  return (
    <>
       {/* <GuestNav/> */}
     <HeadSection
      leftImg={'Polymath-images/Webleftimg.png'}
      rightImg={'Polymath-images/Webrightimg.png'}
      titlePart1="Web Development"
      titlePart2="Course"
      description="A comprehensive course for kids to learn remarkable, Interactive websites using HTML, CSS and Java Script. Polymath-Kids offers the Basic Web Development Course for kids from Grade 1 to 3 and Responsive Web Development Course for Grade 4+. Students will learn the principles of Website creation through website building Projects and can also share their websites with others."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={'Polymath-images/pencil.png'}
      button2Icon={'Polymath-images/pencil.png'}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
       <CourseTimeline
              title1="Course Structure & Syllabus"
              title="Web Development Beginner  Course"
              modules={beginnerModules}
            />
            <CourseTimeline
             
              title="Responsive Web Development Course"
              modules={advancedModules}
            />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Kidprenur Course"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default WebDevelopment